import {
    CREATE_ACCESSORIES_PO_MASTER_REQUEST_DK,
    CREATE_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    CREATE_ACCESSORIES_PO_MASTER_FAILURE_DK,
    DELETE_ACCESSORIES_PO_MASTER_REQUEST_DK,
    DELETE_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    DELETE_ACCESSORIES_PO_MASTER_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_PO_MASTER_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    FETCH_SINGLE_ACCESSORIES_PO_MASTER_FAILURE_DK,
    FETCH_ACCESSORIES_PO_MASTER_REQUEST_DK,
    FETCH_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_MASTER_FAILURE_DK,
    UPDATE_ACCESSORIES_PO_MASTER_REQUEST_DK,
    UPDATE_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    UPDATE_ACCESSORIES_PO_MASTER_FAILURE_DK,
    RESET_ACCESSORIES_PO_MASTER_INFO_DK,
    CREATE_ACCESSORIES_PO_MASTER_FORM_DK,
    UPDATE_ACCESSORIES_PO_MASTER_FORM_DK,
    NAVIGATE_ACCESSORIES_PO_DETAILS_DK,
    NAVIGATE_ACCESSORIES_PO_MASTER_DK,
    FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_SUCCESS_DK,
    FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_FAILURE_DK,
    FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_REQUEST_DK,
    ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_ACCESSORIES_PO_STYLE_REQUEST_DK,
    FETCH_ACCESSORIES_PO_STYLE_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_STYLE_FAILURE_DK,
    FETCH_ACCESSORIES_PO_INVOICE_REQUEST,
    FETCH_ACCESSORIES_PO_INVOICE_SUCCESS,
    FETCH_ACCESSORIES_PO_INVOICE_FAILURE,
    RESET_ACCESSORIES_PO_INVOICE,
    FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_SUCCESS_DK
} from './accessoriesPoMaster.actionsType';

export const ACCESSORIES_PO_MASTER_DK = 'accessoriesPoMasterDK';

let initialState = {
    loading: false,
    accessoriesPoMaster: [],
    accessoriesPoMasterWithoutId: [],
    accessoriesPoInvoice: [],
    accessoriesPoStyleList: [],
    accessoriesPoMasterForm: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    generalItemList: [],
    generalHeaderList: [],
    uomList: [],
    errorMessage: '',
    singleAccessoriesPoData: {},
    isAccessoriesPoDetails: false,
    detailsId: '',
    activeKey: 1
};

export let accessoriesPoMasterDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case FETCH_ACCESSORIES_PO_INVOICE_REQUEST:
        case CREATE_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case UPDATE_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case DELETE_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_REQUEST_DK:
        case FETCH_ACCESSORIES_PO_STYLE_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMaster: updatePayload
            };
        case FETCH_ACCESSORIES_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInvoice: updatePayload
            };
        case FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterWithoutId: updatePayload
            };
        case FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            if (payload == 52) {
                return {
                    ...state,
                    loading: false,
                    typeOfPoList: updatePayload
                };
            } else if (payload == 46) {
                return {
                    ...state,
                    loading: false,
                    sourceList: updatePayload
                };
            } else if (payload == 28) {
                return {
                    ...state,
                    loading: false,
                    departmentList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    deliveryAt: updatePayload
                };
            } else if (payload == 22) {
                return {
                    ...state,
                    loading: false,
                    uomList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalHeaderList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalItemList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case UPDATE_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_ACCESSORIES_PO_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoStyleList: updatePayload
            };
        case FETCH_SINGLE_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterForm: updatePayload
            };
        case DELETE_ACCESSORIES_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case RESET_ACCESSORIES_PO_MASTER_INFO_DK:
            return {
                ...state,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case CREATE_ACCESSORIES_PO_MASTER_FORM_DK:
        case UPDATE_ACCESSORIES_PO_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoMasterForm: {
                    ...state.accessoriesPoMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case FETCH_ACCESSORIES_PO_INVOICE_FAILURE:
        case CREATE_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case UPDATE_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case DELETE_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_FAILURE_DK:
        case FETCH_ACCESSORIES_PO_STYLE_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_ACCESSORIES_PO_DETAILS_DK:
            return {
                ...state,
                isAccessoriesPoDetails: true,
                singleAccessoriesPoData: updatePayload.singleAccessoriesPoData
            };
        case NAVIGATE_ACCESSORIES_PO_MASTER_DK:
            return {
                ...state,
                isAccessoriesPoDetails: false
            };
        case RESET_ACCESSORIES_PO_INVOICE:
            return {
                ...state,
                accessoriesPoInvoice: []
            };
        case ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                accessoriesPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
